// Billing problems are worth seeing while developing, but a stale banner or a
// failed refetch must never be shouted at the customer's console in production.
export const logInDev = (message: string, error: unknown): void => {
  if (process.env.NODE_ENV === 'development') console.error(message, error) // eslint-disable-line no-console
}
